(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', initEmailValidation);

  function initEmailValidation() {
    const emailInputs = document.querySelectorAll('input[type="email"]');

    if (emailInputs.length === 0) return;

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    const errorIcon = '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#e90000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 16H12.01V16.01H12V16Z" stroke="#e90000" stroke-width="2.25" stroke-linejoin="round"></path><path d="M12 12V8" stroke="#e90000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

    emailInputs.forEach((input) => {
      const form = input.closest('form');
      const submitBtn = form?.querySelector('button[type="submit"]') || form?.querySelector('input[type="submit"]');
      // Try to find message element after the input first, then fall back to form-wide search
      const inputWrapper = input.closest('.field');
      const message = inputWrapper?.querySelector('.form__message') || form?.querySelector('.form__message:not(.form__message--success)');
      const successMessage = form?.querySelector('.form__message--success');

      if (!submitBtn) return;

      const showError = () => {
        if (message) {
          const errorText = window.forms?.emailError || 'Please enter a valid email address.';
          message.innerHTML = `${errorIcon}${errorText}`;
        }
        input.classList.add('invalid');
        input.setAttribute('aria-invalid', 'true');
        // Add field--with-error class to parent field wrapper if it exists
        const fieldWrapper = input.closest('.field');
        if (fieldWrapper) {
          fieldWrapper.classList.add('field--with-error');
        }
        submitBtn.setAttribute('disabled', 'true');
        if (successMessage) successMessage.textContent = '';
      };

      const clearError = () => {
        if (message) message.innerHTML = '';
        input.classList.remove('invalid');
        input.setAttribute('aria-invalid', 'false');
        // Remove field--with-error class from parent field wrapper if it exists
        const fieldWrapper = input.closest('.field');
        if (fieldWrapper) {
          fieldWrapper.classList.remove('field--with-error');
        }
        submitBtn.removeAttribute('disabled');
      };

      const validateEmail = () => {
        const emailValue = input.value.trim();

        if (emailValue === '') {
          clearError();
          return;
        }

        const isValid = emailPattern.test(emailValue);

        if (!isValid) {
          showError();
        } else {
          clearError();
        }
      };

      let showTimer, hideTimer;

      const handleInput = () => {
        const emailValue = input.value.trim();
        const isValid = emailPattern.test(emailValue);

        clearTimeout(showTimer);
        clearTimeout(hideTimer);

        if (emailValue === '' || isValid) {
          hideTimer = setTimeout(clearError, 100);
        } else {
          showTimer = setTimeout(showError, 1200);
        }
      };

      input.addEventListener('input', handleInput);
      input.addEventListener('change', validateEmail);
    });
  }
})();